<template>
    <div class="cic-time-picker">
        <el-time-picker
            v-if="enabled"
            :model-value="currentValue"
            :format="format"
            v-bind="Object.assign(JSON.parse(JSON.stringify($attrs)), { id: null })"
            @update:modelValue="handleChange"
        />
        <span v-else>{{ value }}</span>
    </div>
</template>

<script>
    import { ElTimePicker } from 'element-plus';

    export default {
        name: 'CicTimePicker',
        components: {
            'el-time-picker': ElTimePicker,
        },
        props: {
            value: {
                type: String,
                default: null,
            },
            enabled: {
                type: Boolean,
                default: true,
            },
            format: {
                type: String,
                default: 'HH:mm:ss',
            },
        },
        emits: ['input'],
        computed: {
            currentValue() {
                if (this.value) {
                    return new Date('1970-01-01 ' + this.value);
                }

                return null;
            },
        },
        methods: {
            formatTime(val) {
                if (!val) {
                    return '';
                }

                if (this.format === 'HH:mm') {
                    return (
                        val.getHours().toString().padStart(2, '0') + ':' + val.getMinutes().toString().padStart(2, '0')
                    );
                }

                return (
                    val.getHours().toString().padStart(2, '0') +
                    ':' +
                    val.getMinutes().toString().padStart(2, '0') +
                    ':' +
                    val.getSeconds().toString().padStart(2, '0')
                );
            },

            handleChange(val) {
                this.$emit('input', this.formatTime(val));
            },
        },
    };
</script>
